import * as React from "react";
const SvgMicrosoftLogo = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 23 23",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	fill: "#f3f3f3",
	d: "M0 0h23v23H0z"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#f35325",
	d: "M1 1h10v10H1z"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#81bc06",
	d: "M12 1h10v10H12z"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#05a6f0",
	d: "M1 12h10v10H1z"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "#ffba08",
	d: "M12 12h10v10H12z"
}));
export default SvgMicrosoftLogo;
